import { useMutation } from 'react-query';
import { Button, Dropdown } from 'semantic-ui-react';
import toast from 'react-hot-toast';
import { useMemo, useState } from 'react';

import { exportKPIs } from '~/api/admin';

type QuarterOption = {
  key: string;
  text: string;
  value: string;
};

const buildQuarterOptions = (): QuarterOption[] => {
  const options: QuarterOption[] = [{ key: 'all', text: 'All Dates', value: '' }];
  const currentYear = new Date().getFullYear();
  const currentQuarter = Math.floor(new Date().getMonth() / 3) + 1;

  for (let year = currentYear; year >= 2023; year -= 1) {
    const maxQuarterForYear = year === currentYear ? currentQuarter : 4;
    for (let quarter = maxQuarterForYear; quarter >= 1; quarter -= 1) {
      const value = `${year}-Q${quarter}`;
      options.push({
        key: value,
        text: `Q${quarter} ${year}`,
        value
      });
    }
  }

  return options;
};

export default function DownloadKpis() {
  const quarterOptions = useMemo(buildQuarterOptions, []);
  const [selectedQuarter, setSelectedQuarter] = useState<string>('');

  const { mutate: requestKPIExport, status: requestLoadingStatus } = useMutation(async () => {
    try {
      const result = await exportKPIs({
        quarter: selectedQuarter || undefined
      });
      toast.success(result.message);
    } catch (err) {
      console.error(err);
      toast.error('An error occurred while requesting the KPI export. Please refresh the page and try again');
    }
  });

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Dropdown
          selection
          placeholder="Filter by quarter..."
          options={quarterOptions}
          value={selectedQuarter}
          onChange={(_, data) => setSelectedQuarter((data.value as string) || '')}
          style={{ minWidth: 190, fontSize: '14px' }}
        />
      </div>
      <Button
        primary
        size="small"
        disabled={requestLoadingStatus === 'loading'}
        loading={requestLoadingStatus === 'loading'}
        onClick={() => requestKPIExport()}

      >
        Request KPI Export
      </Button>
    </>
  );
}